import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  startVerifyEmail,
  startResendEmail,
  startLogout
} from "../actions/auth";
import mail from "../images/mail.svg";
import LoadingPage from "./LoadingPage";
import "../styles/components/verify-email.scss";
import { message, Row, Col } from "antd";

class VerifyEmail extends React.Component {
  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const token = params.get("token");
    const email = params.get("email");
    if (token && email) {
      this.props.startVerifyEmail(email, token);
    }
  }

  render() {
    const verificationState = () => {
      return this.props.fetchInProgress === true ? (
        <LoadingPage />
      ) : (
        <div className="verify-container">
          <div className="verify-card">
            <div className="verif-header">
              <img src={mail} className="ic-state" alt="done" />
              <div className="verif-info">
                <h2>We've sent verification email. Please check your email.</h2>
              </div>
            </div>
            <Row type="flex" justify="center" align="middle" gutter={32}>
              <Col span={12}>
                <Link
                  to="/login"
                  className="button-login btn-secondary"
                  onClick={() => {
                    this.props.startLogout();
                  }}
                >
                  Login Updamus
                </Link>
              </Col>
              <Col span={12}>
                <Link
                  className="button-login "
                  onClick={() => {
                    this.props.startResendEmail(this.props.userEmail);
                    message.info("Verification email has been sent.");
                  }}
                >
                  Resend Email
                </Link>
              </Col>
            </Row>
          </div>
        </div>
      );
    };
    return <>{verificationState()}</>;
  }
}

const mapStateToProps = state => ({
  fetchInProgress: state.fetchInProgress,
  userEmail: state.auth.email
});

const mapDispatchToProps = dispatch => ({
  startVerifyEmail: (email, token) => dispatch(startVerifyEmail(email, token)),
  startResendEmail: email => dispatch(startResendEmail(email)),
  startLogout: () => dispatch(startLogout())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VerifyEmail);
